import { ApiCommonParams } from "../../@types/apiTypes";
import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function showApologizeRequests(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("v1/students/cancellations", { params });
}
export function changeStudentsRequestStatus(
  id: string | number,
  body: object
): Promise<ApiResponse> {
  return Axios.put(`v1/students/schedule_requests/${id}`, body);
}
export function showChangeScheduleRequests(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});

  return Axios.get("v1/students/schedule_requests", { params });
}
export function changeScheduleRequests(body: object): Promise<ApiResponse> {
  return Axios.put("v1/students/schedules/request_schedule_update", body);
}
